import { action } from 'satcheljs';
/**
 * Enum for the source of the try remove item call
 */
export var RemoveItemSource;
(function (RemoveItemSource) {
    // Action triggered from listview table cleanup
    RemoveItemSource[RemoveItemSource["ListViewTable"] = 0] = "ListViewTable";
    // Action triggered from conversation item part delete
    RemoveItemSource[RemoveItemSource["ConversationItemParts"] = 1] = "ConversationItemParts";
    // Action triggered from single item clean up for reading pane
    RemoveItemSource[RemoveItemSource["ItemCleanUp"] = 2] = "ItemCleanUp";
})(RemoveItemSource || (RemoveItemSource = {}));
/**
 * Action to try delete an item from mailstore.items
 * Remark: This action should be used for all cases where we want to delete from the cache,
 * so that proper ref checking can be done before safely removing the item
 * @param itemIdToRemove - Id of item attempting to be removed
 */
export default action('TRY_REMOVE_FROM_MAIL_STORE_ITEMS', function (itemIdToRemove, removeItemSource) {
    return {
        itemIdToRemove: itemIdToRemove,
        removeItemSource: removeItemSource,
    };
});
//# sourceMappingURL=tryRemoveFromMailStoreItems.js.map